import { AvatarProps, SkeletonProps } from '@mui/material';

export const avatarLoadingVariantMap: Record<AvatarProps['variant'], SkeletonProps['variant']> = {
  circular: 'circular',
  rounded: 'rectangular',
  square: 'rectangular',
};
